// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a029ab480fd4c4fde38d8b47e718cf79752ad647.chunk.bundle.js";
};